package org.chiangmeng.qfast.core.domain.di

import org.chiangmeng.qfast.core.domain.usecases.IssueTicketUseCase
import org.chiangmeng.qfast.core.domain.usecases.NextQueueUseCase
import org.chiangmeng.qfast.core.domain.usecases.ObserveActiveQueuesUseCase
import org.chiangmeng.qfast.core.domain.usecases.ObserveShopUseCase
import org.chiangmeng.qfast.core.domain.usecases.ResetQueueUseCase
import org.koin.dsl.module

val domainModule = module {
    factory { ObserveShopUseCase(get()) }
    factory { ObserveActiveQueuesUseCase(get()) }
    factory { NextQueueUseCase(get()) }
    factory { IssueTicketUseCase(get()) }
    factory { ResetQueueUseCase(get()) }
}